export default (error, getState) => {
    if (!(error.user_id || error.user) && getState) {
        const currentUserId = getState().getIn(['app', 'currentUser', '_id']);
        if (currentUserId) {
            error.user_id = currentUserId;
        }
    }
    return error;
};
